import ivclass from '@invideoio/web-shared/Modules/IVClass';

import IVButton from '@invideoio/uniformd/components/Button';
import ImageComponent from '@components/common/ImageComponent/ImageComponent';
import { useRouter } from 'next/router';

import { getAssetUrl } from '@utils/common.utils';

interface BackButtonPropType {
  isDark: Boolean;
  buttonContent: string;
  redirectLink: string;
}

const BackButton = ({
  isDark,
  buttonContent,
  redirectLink,
}: BackButtonPropType) => {
  const router = useRouter();

  let assetURL = '';
  let assetType = '';

  if (isDark) {
    assetURL += '/icons/arrow-left.svg';
    assetType += 'common';
  } else {
    assetURL += '/icons/left-arrow.svg';
    assetType += 'blog';
  }

  return (
    <IVButton
      onClick={() => router.push(redirectLink)}
      className={ivclass(
        'iv-flex iv-items-center',
        'iv-gap-5',
        'iv-py-5 iv-pr-15 iv-pl-10 ',
        'lg:iv-pl-5',
        'iv-border',
        isDark
          ? ' iv-border-black-50 iv-text-black-50'
          : 'iv-border-grey-0 iv-text-grey-0',
        'iv-text-body-xl iv-font-semibold',
        'iv-rounded-[80px]',
        'focus:iv-outline-none',
      )}
    >
      <ImageComponent
        elementype="native"
        loading="lazy"
        src={getAssetUrl(assetType, assetURL)}
        height={16}
        width={16}
      />
      {buttonContent}
    </IVButton>
  );
};

export default BackButton;
